export default "__VITE_ASSET__hAP$9fwe__";